export default {
	title: "Zahlungsmethoden",
	tips: "Liebe Benutzerin, bitte geben Sie Ihre ERC20/TRC20-Adresse ein. Geben Sie bitte nicht Ihre Bankkontodaten und Ihr Passwort ein",
	form: {
		TransactionPassword: "Transaktionspasswort",
		Address: "Wallet-Adresse"
	},
	label: ["Bankname", "Filialcode", "Filialname", "Einzahlungsart", "Kontonummer", "Kontoinhaber"],
	tabs: ["Bankkarte", "Netzwerk"],
	delete: "Löschen",
	default: "Standard",
	create: "Erstellen",
	type: "Abhebungstyp",
	verifying: "Überprüfung läuft",
	VerifyWalletAddress: "Wallet-Adresse verifizieren",
	defaultAccount: "Standardabhebungskonto",
	deleteMsg: "Sind Sie sicher, dass Sie löschen möchten?"
};
